import { Controller } from "@hotwired/stimulus";

// example: data-controller="shared--preserve-state-search-form">
export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.preserveParams.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("submit", this.preserveParams.bind(this));
  }

  preserveParams(event) {
    event.preventDefault();

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const formData = new FormData(this.element);

    for (let [key, value] of formData.entries()) {
      searchParams.set(key, value);
    }

    searchParams.delete("page");

    url.search = searchParams.toString();
    Turbo.visit(url.toString(), { action: "advance" });
  }
}
